module.exports = __webpack_public_path__ + "img/star.3c0c6158.svg";